
import Step1 from '@/asset/img/jzxs_pc/step_1.png';
import Step2 from '@/asset/img/jzxs_pc/step_2.png';
import Step3 from '@/asset/img/jzxs_pc/step_3.png';
import Step4 from '@/asset/img/jzxs_pc/step_4.png';
import Step5 from '@/asset/img/jzxs_pc/step_5.png';
import file1 from '@/asset/img/jzxs_pc/icon_file1.png';
import file2 from '@/asset/img/jzxs_pc/icon_file2.png';
import './index.css'

function NewPc() {
  const imgs = [Step1, Step2, Step3, Step4, Step5]
  return (
    <div>
      <div className="index-wrap">
        {
          imgs.map(img => {
            return (
              <div className="img-wrap">
                <img src={img} alt="星火悦读"></img>
              </div>
            )
          })
        }
      </div>
      <div className="footer">
        <div className="policy">
          <div>
            <img src={file1} alt="服务协议"></img>
            <a href="http://app.dongyangjiuzhou.com/policy/jzxs/agreement.html" target="_blank" rel="noopener noreferrer">服务协议</a>
          </div>
          <div>
            <img src={file2} alt="隐私政策"></img>
            <a href="http://app.dongyangjiuzhou.com/policy/jzxs/policy.html" target="_blank" rel="noopener noreferrer">隐私政策</a>
          </div>
        </div>
        <div className="company-info">
          <div>官方邮箱：app@hnmoyuwlkj.top</div>
          <div>©2024 海南墨语网络科技有限公司版权所有</div>
          <div>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style={{ textDecoration: 'none', color: '#999' }}>琼ICP备2024035610号</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewPc
